<template>
    <nav>
        <router-link class="nav-obj nav-left logo" to="/home">
            <span>monroe</span>
        </router-link>
        <transition-group name="fade" mode="out-in">
            <div
                v-for="(item, idx) in getPageName()"
                :key="idx + 0 /* TODO: Fix this */"
            >
                <div class="nav-obj nav-left nav-arrow">
                    <MdArrowDroprightIcon/>
                </div>
                <a class="nav-obj nav-left nav-route" @click="$router.push(item.to)">
                    <span
                        v-text="item.name"
                    ></span>
                </a>
            </div>
        </transition-group>
        <div>
            <router-link v-if="!$store.state.user.loggedIn" class="nav-obj nav-right" to="/login"><span>Log In</span></router-link>
            <router-link v-if="$store.state.user.loggedIn" class="nav-obj nav-right" to="/profile"><span>Profile</span></router-link>
            <router-link class="nav-obj nav-right" to="/expo"><span>Expos</span></router-link>
        </div>
    </nav>
</template>

<script>
import MdArrowDroprightIcon from 'vue-ionicons/dist/md-arrow-dropright.vue'

export default {
    name: 'Nav',
    components: {
        MdArrowDroprightIcon
    },
    methods: {
        getPageName() {
            var names = this.$store.state.page.name
            if (!names || names.length == 0 || !names[0].name || names[0].name == 'Home') {
                return []
            } else {
                return names
            }
        }
    }
}
</script>

<style lang="scss" scoped>
nav {
    background-color: black;
    margin: 0;
    padding: 0 10px 0 10px;
    overflow: hidden;
    color: white;
    position: fixed;
    width: 100vw;
    top: 0;
    left: 0;
    will-change: opacity;
    mix-blend-mode: difference;
    z-index: 100;
}

.nav-obj {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 20px 5px 20px;
    margin: 10px;
    height: 50px;
    font-weight: bold;
    border-radius: 20px;
    border: 2px solid white;
    border-color: black;
    margin-left: 0;
    margin-right: 0;
    span {
        display: inline-flex;
        font-size: 20px;
        position: relative;
        top: 1px;
    }
    &.logo {
        span {
            font-size: 35px;
            top: -0.5px;
        }
    }
}

.router-link-active {
    border-color: white;
}

.nav-left {
    float: left;
}
.nav-right {
    float: right;
    margin-left: 10px;
}
.nav-route {
    cursor: pointer;
}
.nav-arrow {
    fill: white;
    padding: 0;
    font-size: 30px;
    position: relative;
    top: 3px;
}

a {
    color: inherit;
    font-size: inherit;
    text-decoration: none;
    transition: all 0.3s ease;
    transition-property: border-color, color, background-color;
}
a:hover {
    color: black;
    background-color: white;
}
</style>